<h1 mat-dialog-title>{{ translateMessage | translate}}</h1>
<h3 mat-dialog-title *ngIf="translateMessageDescription ">{{ translateMessageDescription | translate}}</h3>
<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="true" class="c-white next-btn color-btn" style="font-style: rgb(255, 255, 255);">{{'yes' | translate}}</button>
  <button mat-raised-button (click)="closeDialog()"  class="back-btn">{{'no' | translate}}</button>
</div>
